import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
export const revokeBadgeFormConfig = (t) => ({
    type: 'form',
    children: [
        {
            type: 'form.content',
            html: `<p class="body1" style="color: ${themeColors.text.subtle}">${t('badges.badgeDetails.accountBadgeTable.bulkActions.revoke.description')}</p>`,
        },
        {
            type: 'form.label',
            html: `<p class="subtitle2" style="padding-bottom: 8px;">${t('badges.badgeDetails.accountBadgeTable.menuItems.revoke.modalFormRevokeDetails')}</p>`,
            component: {
                type: 'form.select',
                label: t('badges.badgeDetails.accountBadgeTable.menuItems.revoke.modalFormSelectReason'),
                key: 'revokedBadgeReasonsClassifierId',
                validate: {
                    required: true,
                },
                valueProvider: {
                    type: 'classifier.revokedBadgeReasonsClassifier',
                },
            },
        },
        {
            type: 'form.text',
            key: 'revokeReasonDescription',
            label: t('badges.badgeDetails.accountBadgeTable.menuItems.revoke.modalFormDetails'),
            multiline: true,
            rows: 5,
        },
    ],
});
